import { types } from "../types/types";

const INITIAL_STATE = {
  insurers: null,
};

const insurersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.addInsurers:
      return {
        ...state,
        insurers: action.payload,
      };
    case types.removeInsurers:
      return {
        ...state,
        insurers: null,
      };
    default:
      return state;
  }
};

export default insurersReducer;
